<template>
    <header :theme="theme">
        <div class="gdpr-ribbon" v-if="gdpr">
            <div class="constrain bc flex flex-align">
                <div class="ff">Our site uses cookies so that we can remember you and understand how you use our product.</div>
                <div class="text-button white border" @click="close">I Understand</div>
                <a class="text-button grey border" href="https://ed.link/docs/legal/privacy" target="_blank">Learn More</a>
            </div>
        </div>
        <div class="header-constraint constrain bc">
            <div class="flex flex-align" v-if="user.user_id">
                <router-link class="wordmark" :to="{name: 'library'}">Library</router-link>
                <template v-if="product">
                    <div class="slash">/</div>
                    <div class="organization flex flex-align">
                        <router-link class="organization-name breadcrumb" :to="{name: 'product.contents', params: {product: product.product_slug}}">{{product.product_title}}</router-link>
                        <div class="organization-switch" @click="change"></div>
                    </div>
                </template>
                <div class="ff"></div>
                <a class="block theme-selector" @click="toggle_theme"></a>
                <router-link class="destination" to="/support">Support</router-link>
                <div class="flex flex-align user-metadata" @click="options">
                    <div class="username destination">{{user.user_display_name}}</div>
                    <profile :user="user" class="profile-picture" />
                </div>
            </div>
            <div class="flex flex-align" v-else>
                <router-link class="wordmark" :to="{name: 'home'}">Simulation Curriculum</router-link>
                <div class="ff"></div>
                <a class="block theme-selector" @click="toggle_theme"></a>
                <router-link class="destination" to="/support">Support</router-link>
                <div class="button" @click="login">Sign In</div>
            </div>
        </div>
    </header>
</template>

<script>
    const url = process.env.VUE_APP_APPLICATION_URL;

    import Options from '@/components/modals/Options.vue';
    import SwitchProduct from '@/components/modals/SwitchProduct.vue';

    export default {
        name: 'Header',
        data(){
            return {
                gdpr: true
            };
        },
        methods: {
            options(){
                const _this = this;

                this.$modal.show(Options, {
                    options: [
                        {
                            color: 'red',
                            title: 'Sign Out',
                            fn(){
                                _this.$store.dispatch('user/logout')
                                .then(() => _this.$router.push({name: 'home'}))
                                .catch(() => _this.$toasted.error('There was an error logging you out.'));
                            }
                        }
                    ]
                },
                {
                    width: 260,
                    height: 'auto',
                    classes: 'modal'
                });
            },
            close(){
                localStorage.setItem('gdpr', true);
                this.gdpr = false;
            },
            change(){
                this.$modal.show(SwitchProduct, {}, {width: 320, height: 'auto', classes: 'modal'});
            },
            serialize(object){
                const str = [];

                for(const [key, value] of Object.entries(object)){
                    str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                }

                return str.join('&');
            },
            login(){
                //Construct the authorization URL
                const parameters = {
                    client_id: '9dd97a42-b66b-46d0-a349-e183286f3568',
                    redirect_uri: `${url}/api/login`,
                    state: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                };

                window.location = `https://ed.link/sso/login?${this.serialize(parameters)}`;
            },
            toggle_theme(){
                this.$store.dispatch('theme/toggle');
            }
        },
        created(){
            if(localStorage.getItem('gdpr')){
                this.gdpr = false;
            }
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            user(){
                return this.$store.state.user;
            },
            theme(){
                return this.$store.state.theme.active;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    header
    {
        .wordmark, .slash, .organization, .breadcrumb
        {
            font-size: 18px;
            font-weight: 500;
            color: var(--primary-text-color);
            letter-spacing: -0.03rem;
        }

        .wordmark
        {
            height: 42px;
            line-height: 42px;
            display: block;
            padding-left: 70px;
            background-image: url('~@/assets/logo-white.svg');
            background-position: 0 8px;
            background-repeat: no-repeat;
            background-size: 56px auto;
        }

        &[theme="light"]
        {
            .wordmark
            {
                background-image: url('~@/assets/logo-black.svg');
            }
        }

        .slash
        {
            color: @c;
            font-weight: 300;
            margin: 0 10px;
        }

        .breadcrumb
        {
            color: @grey;
            font-weight: 400;
            letter-spacing: -0.02rem;
        }

        .username
        {
            color: var(--primary-text-color);
        }

        .profile-picture
        {
            width: 32px;
            height: 32px;
            margin-left: 10px;
            cursor: pointer;
            border-radius: 16px;
            overflow: hidden;

            img
            {
                width: 32px;
                height: 32px;
            }
        }

        .register
        {
            margin-left: 30px;
        }
    }

    .header-constraint
    {
        padding-top: 14px;

        .button
        {
            margin-left: 30px;
            line-height: 32px;
            height: 32px;
        }
    }

    .organization-switch
    {
        width: 17px;
        height: 28px;
        border-radius: 2px;
        margin-left: 8px;
        background: url('~@/assets/icons/black/select.svg') -1px 6px no-repeat;
        background-size: 18px auto;
        cursor: pointer;

        &:hover, &:active
        {
            background-color: @e;
        }
    }

    .theme-selector
    {
        width: 30px;
        height: 30px;
        background: url('~@/assets/icons/black/moon.svg') 5px 3px no-repeat;
        background-size: 22px auto;
        cursor: pointer;
    }

    [theme="dark"]
    {
        .organization-switch
        {
            background-image: url('~@/assets/icons/white/select.svg');

            &:hover, &:active
            {
                background-color: #333;
            }
        }

        .theme-selector
        {
            background-image: url('~@/assets/icons/grey/sun.svg');
            background-position: 4px 4px;
            background-size: 22px auto;
        }
    }

    .gdpr-ribbon, .downtime-ribbon
    {
        height: 48px;
        background: var(--card-background-color);
        color: var(--primary-text-color);
        font-weight: 500;
        font-size: 14px;

        .constrain
        {
            height: 100%;
        }

        .text-button.border
        {
            font-size: 12px;
            padding: 2px 10px;
            margin-left: 10px;

            &:hover, &:active
            {
                background: transparent;
            }
        }
    }

    .downtime-ribbon
    {
        background: @red;
    }
</style>
